import environment from "../environments/environment.json";

let loadPromise = null;

export function loadVerisoulScript(projectId) {
  const resolvedProjectId = projectId || environment.VERISOUL_PROJECT;

  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = `https://js.verisoul.ai/${environment.VERISOUL_ENVIRONMENT}/bundle.js`;
    script.async = false;
    script.setAttribute("verisoul-project-id", resolvedProjectId);
    script.onload = () => resolve();
    script.onerror = (e) => {
      loadPromise = null;
      reject(e);
    };
    document.body.appendChild(script);
  });

  return loadPromise;
}
